// extracted by mini-css-extract-plugin
module.exports = {"wrapper__subtitle":"GeneratePartnerTrackingCode_wrapper__subtitle__1H2tF"};